'use client';

import { createContext, useContext } from 'react';

import type { Id } from '@/convex/_generated/dataModel';
import type { BrowserNotificationPermissionController } from './browser-notification-permission';

export type WorkspaceNotificationContextValue = {
  orgSlug?: string;
  organizationId?: Id<'organizations'>;
  /** Bell dot: an agent is blocked waiting on the viewer. */
  hasPendingQuestion: boolean;
  browserPermission: BrowserNotificationPermissionController;
};

export const WorkspaceNotificationContext =
  createContext<WorkspaceNotificationContextValue | null>(null);

export function useWorkspaceNotifications(): WorkspaceNotificationContextValue {
  const context = useContext(WorkspaceNotificationContext);
  if (!context) {
    throw new Error(
      'useWorkspaceNotifications must be used inside WorkspaceNotificationProvider'
    );
  }
  return context;
}

/** For surfaces that also render outside the provider. */
export function useOptionalWorkspaceNotifications(): WorkspaceNotificationContextValue | null {
  return useContext(WorkspaceNotificationContext);
}
